/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import LayoutPublicRoutes from "@/src/containers/Layouts/LayoutPublicRoutes";
import DismissalCheckWbsPageMeta from "./DismissalCheckWbsPageMeta";
import LandingPageTeaser from "@/src/components/Teaser/LandingPageTeaser";
import CustomerFeedback from "@/src/components/Sections/Generic/CustomerFeedback/CustomerFeedback";
import Container from "@/src/components/Container/Container";
import DismissalCheckin from "@/src/components/Checkin/DismissalCheckin/DismissalCheckin";
import SettlementTimeSection from "@/src/components/Sections/Settlement/SettlementTimeSection/SettlementTimeSection";
import TeamSection from "@/src/components/Sections/Generic/TeamSection/TeamSection";
import PartnerLogoSection from "@/src/components/Sections/Generic/PartnerLogoSection/PartnerLogoSection";
import { settlementTeaserCards } from "@/src/services/landingPageService";
import LinkedCardBox from "@/src/components/LinkedCardBox/LinkedCardBox";
import { useCustomer } from "@/src/provider/Customer/CustomerProvider";
import NoWinNoFeeSection from "@/src/components/Sections/Settlement/NoWinNoFeeSection/NoWinNoFeeSection";
import PartnersSection from "@/src/components/Sections/Generic/PartnersSection/PartnersSection";
import HowItWorksSectionSettlement from "@/src/components/Sections/Settlement/HowItWorksSection/HowItWorksSectioSettlement";
import { PARTNER_IRIS } from "@/src/constants/partnerIris";

const DismissalCheckWbsPage = () => {
  const { isLoggedIn } = useCustomer();

  return (
    <LayoutPublicRoutes>
      <DismissalCheckWbsPageMeta />
      <LandingPageTeaser
        headline={"Kündigung? Jetzt prüfen lassen!"}
        subheadline={"Wir begleiten Sie professionell bei Ihrer Kündigung"}
        hasTeaserButton={true}
        teaserButtonText={"Kostenlos prüfen lassen"}
        teaserButtonLink={isLoggedIn ? "/servicewelt" : "#top-checkin"}
      >
        <PartnerLogoSection partnerIri={PARTNER_IRIS.WBS} containerStyle={"settlementContainer"} />
        <LinkedCardBox linkedCards={settlementTeaserCards} />
      </LandingPageTeaser>
      {!isLoggedIn && (
        <Container>
          <DismissalCheckin idPrefix={"top"} partner={PARTNER_IRIS.WBS} />
        </Container>
      )}
      <HowItWorksSectionSettlement />
      <NoWinNoFeeSection />
      <SettlementTimeSection />
      <TeamSection headline={"Sie möchten professionell gegen Ihre Kündigung angehen?"} subHeadline={"Wir kümmern uns persönlich um Sie"} />
      <CustomerFeedback />
      <PartnersSection />
      {!isLoggedIn && (
        <Container>
          <DismissalCheckin idPrefix={"bottom"} partner={PARTNER_IRIS.WBS} />
        </Container>
      )}
    </LayoutPublicRoutes>
  );
};

export default DismissalCheckWbsPage;
